import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ItemProdutoInserirComponent } from './item-produto-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ItemProdutoInserirComponent }
    ])],
    exports: [RouterModule]
})
export class ItemProdutoInserirRoutingModule { }
